﻿// depends-on: Bootstrap
/* global require */
(function ($) {
    // Eightfold Way glossary plugins
    var _ = require('lodash');

    // handle horizontal scrolling of alpha index
    $.fn.efw$glossaryindex = function (options) {
        var opts = jQuery.extend({}, $.fn.efw$glossaryindex.defaults, options);

        return this.each(function () {
            let $this = $(this),
                $items = $this.find('.alpha-index-items'),
                $left = $this.find('.alpha-scroll.left'),
                $right = $this.find('.alpha-scroll.right'),
                $scrolls = $this.find('.alpha-scroll'),
                u,  // width of one button
                d,  // visible window, the space between our buttons
                w,  // width of the scrolling index.
                delta;    // distance to scroll per button click

            this.resetScale = function () {
                // first check to see if we're clipping at all
                if ($(window).width() < opts.maxContainer) {
                    $scrolls.css('display', 'flex');
                    // adjust the edges to full-screen
                    $(this).css({ marginLeft: '-15px', marginRight: '-15px', justifyContent: 'start' });
                    u = $right.width();
                    d = $right.offset().left - ($left.offset().left + $left.width());
                    w = $this[0].scrollWidth; // full overflowed width
                    delta = Math.min(d, opts.minOffset * 4);
                    this.params = {
                        min: d + 2 * u - w,
                        max: u,
                        target: u
                    };
                    $items.stop().css('left', this.params.target + 'px');
                    $left.addClass('disabled');
                    // tell each button how far to scroll per click
                    $left.data('delta', delta);
                    $right.data('delta', -delta);
                } else {
                    $scrolls.css('display', 'none');
                    // adjust the edges to display area
                    $(this).css({ marginLeft: '0', marginRight: '0', justifyContent: 'center' });
                    $items.stop().css('left', 'auto');
                }
                // refresh the scrollspy
                $('body').scrollspy('refresh');

            };

            this.scrollToTarget = function () {
                $scrolls.removeClass('disabled');
                // console.log('computing: ' + this.params.target + ' + ' + $(e.currentTarget).data('delta'));
                // condition target position
                if (this.params.target > this.params.max) {
                    $left.addClass('disabled');
                    this.params.target = this.params.max;
                } else if (this.params.target < this.params.min) {
                    $right.addClass('disabled');
                    this.params.target = this.params.min;
                }
                // console.log('...animating to ' + this.params.target);
                $items.stop().animate({ left: this.params.target + 'px' });
            };

            // interact with Bootstrap ScrollSpy.
            // on ScrollSpy activation change, scroll the activated index element into view.
            // event activate.bs.scrollspy is fired on $(window) when spying on the <body>? https://github.com/twbs/bootstrap/issues/20086
            $(window).on('activate.bs.scrollspy', _.bind(function () {
                let $active = $this.find('.active');
                if ($active.length > 0 && $left.is(':visible') && $right.is(':visible')) {
                    // find the edges of the active link relative to the document
                    let al = $active.offset().left,
                        ar = al + $active.outerWidth();
                    // ...and the window, between the two scroll buttons
                    let l = $left.offset().left + $left.outerWidth(),
                        r = $right.offset().left;
                    if (ar <= l) {
                        // we are out of window to the left
                        this.params.target += (l - al); // scroll until the whole active block is visible
                    } else if (al >= r) {
                        // we are out of window to the right
                        this.params.target -= (ar - r);
                    } else {
                        return;
                    }
                    //console.log('scrollspy: scrolling to ' + this.params.target);
                    this.scrollToTarget();
                }
            }, this));

            // do nothing if we're in edit-mode.
            if ($this.closest('.edit-mode').length > 0)
                return;

            this.resetScale();  // establish scale.

            // When window resizes, recompute the visible window.
            // debounce the call to minimize calls while actively resizing.
            $(window).resize(_.bind(_.debounce(this.resetScale, 150), this));

            // click handlers for the left and right buttons.
            // note _.bind; "this" is outer this. Scroller clicked is e.currentTarget.
            $scrolls.on('click', _.bind(function (e) {
                e.preventDefault();
                this.params.target += $(e.currentTarget).data('delta');
                this.scrollToTarget();
            }, this));
        });
    };

    $.fn.efw$glossaryindex.defaults = {
        index: '.alpha-index',
        minOffset: 41,
        maxContainer: 1110
    };

    // Eightfold Way glossary initialization
    $(document).ready(function () {
        // activate ScrollSpy on glossary page
        $('body').scrollspy({
            target: $('.alpha-index')
        });

        // activate alpha index scrolling on glossary page
        $('.alpha-index').efw$glossaryindex();
    });
})(jQuery);
